import { PayloadActionData } from 'models';
import {
  PURCHASE_HISTORY_PARAMS_REQUEST,
  SITTER_AC_PARAMS_REQUEST,
  SUBSCRIPTION_PARAMS_REQUEST,
} from 'models/subscription';

export const GET_SUBSCRIPTION_LIST_REQUEST: string =
  'GET_SUBSCRIPTION_LIST_REQUEST';
export const GET_SUBSCRIPTION_DETAIL_REQUEST: string =
  'GET_SUBSCRIPTION_DETAIL_REQUEST';
export const GET_BASE_REQUEST_DETAIL_REQUEST: string =
  'GET_BASE_REQUEST_DETAIL_REQUEST';
export const DELETE_SUBSCRIPTION_REQUEST: string =
  'DELETE_SUBSCRIPTION_REQUEST';
export const GET_SITTER_AC_LIST_REQUEST: string = 'GET_SITTER_AC_LIST_REQUEST';
export const DELETE_SITTER_AC_REQUEST: string = 'DELETE_SITTER_AC_REQUEST';
export const GET_AC_PURCHASE_HISTORY_LIST_REQUEST: string =
  'GET_AC_PURCHASE_HISTORY_LIST_REQUEST';

export const getSubscriptionListRequest = (
  params?: SUBSCRIPTION_PARAMS_REQUEST | null
) => {
  return {
    type: GET_SUBSCRIPTION_LIST_REQUEST,
    payload: { params },
  };
};

export const deleteSitterACAction = (payload: {
  id: string;
  onSuccess?: () => void;
}) => {
  return {
    type: DELETE_SITTER_AC_REQUEST,
    payload,
  };
};

export const getSubscriptionDetailAction = (
  payload: PayloadActionData<{ id: string }>
) => {
  return {
    type: GET_SUBSCRIPTION_DETAIL_REQUEST,
    payload,
  };
};

export const getBaseRequestDetailAction = (
  payload: PayloadActionData<{ id: string | undefined }>
) => {
  return {
    type: GET_BASE_REQUEST_DETAIL_REQUEST,
    payload,
  };
};

export const getSitterACListRequest = (
  params?: SITTER_AC_PARAMS_REQUEST | null
) => {
  return {
    type: GET_SITTER_AC_LIST_REQUEST,
    payload: { params },
  };
};

export const getACPurchaseHistoryAction = (
  params?: PURCHASE_HISTORY_PARAMS_REQUEST
) => {
  return {
    type: GET_AC_PURCHASE_HISTORY_LIST_REQUEST,
    payload: { params },
  };
};
